var _path, _path2, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHowItWorksLineFour = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 90"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint0_linear_3085_71886)",
  d: "M7 0v25.62L1 38.76V90"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint1_linear_3085_71886)",
  d: "M7 0v25.62L1 38.76V90",
  className: "active-line"
})), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3085_71886",
  x1: 4,
  x2: 4,
  y1: 0,
  y2: 90,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3085_71886",
  x1: "0%",
  x2: "0%",
  y1: 0,
  y2: "100%",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 1
  }
}))));
export { SvgHowItWorksLineFour as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMFYyNS42MjA0TDEgMzguNzU5MVY5MCIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfMzA4NV83MTg4NikiLz4KPHBhdGggY2xhc3M9ImFjdGl2ZS1saW5lIiBkPSJNNyAwVjI1LjYyMDRMMSAzOC43NTkxVjkwIiBzdHJva2U9InVybCgjcGFpbnQxX2xpbmVhcl8zMDg1XzcxODg2KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzMwODVfNzE4ODYiIHgxPSI0IiB5MT0iMCIgeDI9IjQiIHkyPSI5MCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRTBFMEVCIiBzdG9wLW9wYWNpdHk9IjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTBFMEVCIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl8zMDg1XzcxODg2IiB4MT0iMCUiIHkxPSIwIiB4Mj0iMCUiIHkyPSIxMDAlIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgPHN0b3Agb2Zmc2V0PSI3MCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMyRjY0RUQ7c3RvcC1vcGFjaXR5OjAiIC8+CiAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojMkY2NEVEO3N0b3Atb3BhY2l0eToxIiAvPgogIDwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";